
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import Vue from "vue";
import AppIframeSettings from "./IframeSettings.vue";
import AppImageSettings from "./ImageSettings.vue";
import AppRevenuePerMonthCompareSettings from "./RevenuePerMonthCompareSettings.vue";
import AppPurchasePerMonthCompareSettings from "./PurchasePerMonthCompareSettings.vue";
import AppChartDataSettings from "./ChartDataSettings.vue";
import AppChartDataWithBanksSettings from "./ChartDataWithBanksSettings.vue";
import AppTaskListSettings from "./TaskListSettings.vue";
import AppRevenueLastMonthCompareSettings from "./RevenueLastMonthCompareSettings.vue";
import AppYearOverviewPerMonthSettings from "./YearOverviewPerMonthSettings.vue";
import AppBankDataSettings from "./BankDataSettings.vue";
import AppToPayVatSettings from "./ToPayVatSettings.vue";
import AppPurchaseChartDataSettings from "./PurchaseChartDataSettings.vue";

export default Vue.extend({
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		title: {
			type: String,
			default():string{
				return this.$ct("common.settings").toString();
			}
		}
	},
	computed: {
		componentName():string{
			return `App${this.item.getSettingsComponentName()}`;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		onConfirm(){
			this.$emit("confirm");
		}
	},
	components: {
		AppIframeSettings,
		AppImageSettings,
		AppRevenuePerMonthCompareSettings,
		AppChartDataSettings,
		AppTaskListSettings,
		AppYearOverviewPerMonthSettings,
		AppBankDataSettings,
		AppChartDataWithBanksSettings,
		AppToPayVatSettings,
		AppPurchasePerMonthCompareSettings,
		AppRevenueLastMonthCompareSettings,
		AppPurchaseChartDataSettings,
	}
});
